import { openDB } from "idb";

const dbp = openDB("dropit", 3, {
  upgrade(db, oldVersion) {
    if (oldVersion < 1) {
      db.createObjectStore("dispatches", { keyPath: "id" });
      db.createObjectStore("properties", { keyPath: "id" });
      db.createObjectStore("outbox", { keyPath: "idempotency_key" });
      db.createObjectStore("drafts");
      db.createObjectStore("meta");
    }
    if (oldVersion < 2) db.createObjectStore("crew", { keyPath: "id" });
    if (oldVersion < 3) { db.createObjectStore("contractor_jobs", { keyPath: "token" }); db.createObjectStore("contractor_queue", { keyPath: "id" }); }
  },
});

export const db = {
  async putAll(store, rows) { const d = await dbp; const tx = d.transaction(store, "readwrite"); await Promise.all([...rows.map((r) => tx.store.put(r)), tx.done]); },
  async all(store) { return (await dbp).getAll(store); },
  async get(store, key) { return (await dbp).get(store, key); },
  async put(store, value, key) { return (await dbp).put(store, value, key); },
  async del(store, key) { return (await dbp).delete(store, key); },
  async clear(store) { return (await dbp).clear(store); },
};

export const closeDb = async () => { (await dbp).close(); };

export const mirrorDispatches = async (rows) => { await db.clear("dispatches"); await db.putAll("dispatches", rows); };
